import { useCallback } from 'react';

import { ConversationalMMAnalyticsEvent } from '../analytics/events';
import { useConversationalMMContext } from '../context/ConversationalMMContextBase';

const useAdvanceTooltip = () => {
    const { setActiveTooltip, tooltipSequence, onTrackEvent } =
        useConversationalMMContext();

    const advanceTooltip = useCallback(() => {
        setActiveTooltip((current) => {
            if (current == null) return null;

            const idx = tooltipSequence.indexOf(current);
            if (idx === -1) return null;

            onTrackEvent(ConversationalMMAnalyticsEvent.TooltipPressed, {
                tooltipId: current,
            });

            if (idx >= tooltipSequence.length - 1) {
                onTrackEvent(
                    ConversationalMMAnalyticsEvent.TooltipsSequenceDone,
                );
                return null;
            }
            return tooltipSequence[idx + 1] ?? null;
        });
    }, [tooltipSequence, setActiveTooltip, onTrackEvent]);

    return advanceTooltip;
};

export default useAdvanceTooltip;
